import type { FC } from 'react';

import selfStyles from './index.module.scss';
import { TabsProps, UniTabs } from '..';

export const Tabs: FC<TabsProps> = (props) => <UniTabs {...props} selfStyles={selfStyles} />;
